import { useMainSelector } from '../../useMainSelector';

export const useExportConfig = () => {
  const {
    settings: { exportConfigs, selectedExportConfig },
  } = useMainSelector();

  return {
    exportConfigs,
    selectedExportConfig,
  };
};
